(function(EnvironmentVariable) {
	
	const INDETERMINATE = 'indeterminate';
	const DETERMINATE 	= 'determinate';
	
	class Loader {
		
		constructor($scope, target){
			this.$scope = $scope;

			if($scope.isEnabled){
				this.setEnable();
			}
			else{
				this.setDisable();
			}
			this.setValueMode($scope.valueMode ? $scope.valueMode : 0);
			
			this._setTypeMode($scope.typeMode ? $scope.typeMode : INDETERMINATE);
			this._setDiameter($scope.diameter ? $scope.diameter : 50);
			this._setCssClass($scope.cssClass ? $scope.cssClass : '');
			this._setTarget(target);
		}
		
		/**
		 * PRIVATE
		 */
		
		_setTypeMode(typeMode){
			if(typeMode == INDETERMINATE || typeMode == DETERMINATE){
				this.typeMode = typeMode;
			}
		}
		
		_setDiameter(diameter){
			this.diameter = diameter;
		}
		
		_setTarget(target){
			this.target = target;
		}
		
		_setCssClass(cssClass){
			this.cssClass = cssClass;
		}
		
		/**
		 * PUBLIC GETTERS
		 */
		isEnabled(){
			return this.enabled;
		}
		
		getDiameter(diameter){
			return this.diameter;
		}
		
		getTypeMode(){
			return this.typeMode;
		}
		
		getValueMode(){
			return this.valueMode;
		}
		
		getTarget(){
			return this.target;
		}
		
		getCssClass(){
			return this.cssClass;
		}
		
		/**
		 * PUBLIC SETTER
		 */
		setEnable(){
			if(!this.enabled){
				this.enabled = true;
				this.$scope.$applyAsync();
			}
		}
		
		setDisable(){
			if(this.enabled) {
				this.enabled = false;
				this.$scope.$applyAsync();
			}
		}
		
		setValueMode(valueMode){
			if(this.typeMode == INDETERMINATE){
				this.valueMode = valueMode;
			}
		}
	}

	window.Loader = Loader;
}(window.EnvironmentVariable));